import React, { useEffect, useState } from "react";
import { Button, Input, Pagination, Table, Tooltip, Whisper } from "rsuite";
import { handleDownloadAsExcel } from "../../../Helpers/Utils";
import { AccountsVM } from "../../../Models/ViewModels";
import { GetAccountDetails } from "../../../Services/AccountsDB";
import { BootstrapIcon } from "../../../SharedComponents/BootstrapIcon";
import { CustomTableCell } from "../../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../../SharedComponents/CustomTableHeaderCell";
import { PageHeader } from "../../../SharedComponents/PageHeader";
import { AccountModal } from "./AccountModalDisp";
const { Column, HeaderCell, Cell } = Table;
export const AccountList = () => {
  const [cachedAccountList, setCachedAccountList] = useState(
    new Array<AccountsVM>()
  );
  const [sortColumn, setSortColumn] = useState();
  const [isLoading, setLoading] = useState(true);
  const [sortType, setSortType] = useState();
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredAccountList, setFilteredAccountList] = useState(
    new Array<AccountsVM>()
  );

  const [searching, setSearching] = useState(false);

  useEffect(() => {
    GetAccountList();
  }, []);

  const GetAccountList = () => {
    GetAccountDetails().then((res) => {
      setCachedAccountList(res.data);
      setFilteredAccountList(res.data);
      setLoading(false);
    });
  };

  const handleFilterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredAccountList(
        cachedAccountList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredAccountList([...cachedAccountList]);
      setSearching(false);
    }
  };

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const tableDataFeed = filteredAccountList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return filteredAccountList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  const AccountInfo: AccountsVM = new AccountsVM();

  const addAccount = (accDetail: AccountsVM) => {
    GetAccountList();
  };
  const editAccount = (accDetail: AccountsVM) => {
    GetAccountList();
  };
  const deleteAccount = (accDetail: AccountsVM) => {
    GetAccountList();
  };
  return (
    <>
      <div className="row">
        <div className="col-md-7">
          <PageHeader title="Account Master" backPage="">
            <></>
          </PageHeader>
        </div>
        <div className="col-md-3">
          <Input
            className="form-control border border-dark"
            placeholder="Search..."
            type={"search"}
            id="search"
            onChange={handleFilterData}
          />
        </div>
        <div className="col-md-1">
          {searching == true ? (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(tableDataFeed)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={30}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          ) : (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(cachedAccountList)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={30}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          )}
        </div>
        <div className="col">
          <AccountModal
            action="add"
            data={AccountInfo}
            cachedData={cachedAccountList}
            onAction={addAccount}
          />
          <br />
        </div>
        <hr />
      </div>

      <div className="show-container" bg-color="pink">
        <Table
          id="table"
          height={450}
          data={tableDataFeed}
          loading={isLoading}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          bordered={true}
          cellBordered={true}
          className="border border-dark mt-2"
          autoHeight={true}
          rowHeight={30}
          headerHeight={30}
        >
          <Column flexGrow={80} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"ID"}>ID</CustomTableHeaderCell>
            <CustomTableCell dataKey="AccountID" />
          </Column>

          <Column flexGrow={400} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Account Name"}>
              Account Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="AccountName" />
          </Column>

          <Column flexGrow={80} align="center" fixed>
            <CustomTableHeaderCell placement={"Account Code"}>
              Account Code
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="AccountCode" />
          </Column>

          <Column flexGrow={100} align="center" fixed>
            <CustomTableHeaderCell placement={"VC Account Ref ID"}>
              VC Account Ref ID
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="VCAccountRefID" />
          </Column>
          <Column flexGrow={80} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Status"}>
              Status
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="IsActive" />
          </Column>
          <Column flexGrow={100} align="center" fixed>
            <CustomTableHeaderCell placement={"End Date"}>
              End Date
            </CustomTableHeaderCell>
            <CustomTableCell>
              {(rowData: AccountsVM) => {
                if (rowData.EndDate === "") return <div></div>;
                else return <div>{rowData.EndDate}</div>;
              }}
            </CustomTableCell>
          </Column>
          <Column flexGrow={100} align="center">
            <CustomTableHeaderCell placement={"Action"}>
              Action
            </CustomTableHeaderCell>
            <CustomTableCell>
              {(rowData: AccountsVM) => {
                if (rowData.IsActive === "Active") {
                  return (
                    <div className="d-flex justify-content-center align-items-center flex-row gap-2">
                      <AccountModal
                        action="delete"
                        data={rowData}
                        cachedData={cachedAccountList}
                        onAction={deleteAccount}
                      />
                      <AccountModal
                        action="edit"
                        data={rowData}
                        cachedData={cachedAccountList}
                        onAction={editAccount}
                      />
                    </div>
                  );
                } else {
                  return (
                    <BootstrapIcon
                      bootStrapIconName="x-circle-fill text-danger"
                      size={15}
                      cssClasses="me-1"
                    ></BootstrapIcon>
                  );
                }
              }}
            </CustomTableCell>
          </Column>
        </Table>

        {filteredAccountList && (
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredAccountList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        )}
      </div>
    </>
  );
};
